import { type FC } from 'react';
import { OperationBreadcrumb } from './OperationBreadcrumb';
import { VesselBreadcrumb } from './VesselBreadcrumb';
import { type TargetVessel } from '../../../types';
import { type SearchContext } from '../types';
import { useDetectMobileScreenWidth } from '../../../hooks/useDetectMobileScreenWidth';
import type React from 'react';

export interface Props {
  operation: string;
  isWorldView: boolean;
  onBreadcrumbClick: () => void;
  onOperationSelect: (operationKey: string) => void;
  targetVessel: TargetVessel;
  onVesselSelected: (mmsi: string, vesselName: string) => void;
  context: SearchContext;
}

export const SearchBreadcrumbs: FC<Props> = ({
  operation,
  isWorldView,
  onOperationSelect,
  onBreadcrumbClick,
  targetVessel,
  onVesselSelected,
  context,
}) => {
  const isMobileView = useDetectMobileScreenWidth();

  const handleOperationReset = (event: React.MouseEvent<SVGElement, MouseEvent>): void => {
    onOperationSelect(null);
    event.stopPropagation();
  };

  const handleVesselReset = (event: React.MouseEvent<SVGElement, MouseEvent>): void => {
    onVesselSelected(null, null);
    event.stopPropagation();
  };

  return (
    <div className="search-breadcrumbs-container text-sm-medium">
      <OperationBreadcrumb
        operation={operation}
        isWorldView={isWorldView}
        context={context}
        isMobileView={isMobileView}
        onOperationClick={onBreadcrumbClick}
        onOperationReset={handleOperationReset}
      />
      <VesselBreadcrumb
        targetVessel={targetVessel}
        context={context}
        onVesselClick={onBreadcrumbClick}
        onVesselReset={handleVesselReset}
      />
    </div>
  );
};
